// Session de l'utilisateur connecté
import { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { api, definirSurSessionExpiree, enregistrerJeton, lireJeton } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [utilisateur, setUtilisateur] = useState(null);
  // Tant qu'on vérifie un jeton existant, on n'affiche pas la page de connexion
  const [verification, setVerification] = useState(Boolean(lireJeton()));

  const deconnexion = useCallback(() => {
    enregistrerJeton(null);
    setUtilisateur(null);
  }, []);

  useEffect(() => {
    definirSurSessionExpiree(deconnexion);
    if (!lireJeton()) return;
    api('/auth/moi')
      .then(setUtilisateur)
      .catch(deconnexion)
      .finally(() => setVerification(false));
  }, [deconnexion]);

  const connexion = async (identifiant, motDePasse) => {
    const { jeton, utilisateur: u } = await api('/auth/connexion', {
      methode: 'POST',
      corps: { identifiant, motDePasse },
    });
    enregistrerJeton(jeton);
    setUtilisateur(u);
  };

  return (
    <AuthContext.Provider value={{ utilisateur, verification, connexion, deconnexion }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);

/** Droits selon le rôle (mêmes règles que le backend) */
export function useDroits() {
  const { utilisateur } = useAuth();
  const role = utilisateur?.role;
  const superAdmin = role === 'SUPER_ADMIN';
  return {
    superAdmin,
    // clients, versions
    admin: superAdmin || role === 'ADMIN',
    // postes, autorisations, mises à jour
    support: superAdmin || role === 'ADMIN' || role === 'SUPPORT',
  };
}
